
const rts = {
  handleInit_fpw: 'handleInit_fpw',
  handleWideMode: 'handleWideMode',
}

export const fullPageWrapperInitialState = (initState) => {
  return { ...initState, wideModeOn: false }
};

export const fullPageWrapperReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleInit_fpw:
      console.log('handleInit_fpw', action.fpwProps)
      return { ...state, fpwProps: action.fpwProps }

    case rts.handleWideMode:
      return { ...state, wideModeOn: action.wideModeOn }

    default:
      return state;
  }
}

export const fullPageWrapperHandlers = (dispatch) => {
  return {
    handleInit_fpw: (fpwProps) => { dispatch({ type: rts.handleInit_fpw, dispatch, fpwProps }) },
    handleWideMode: (wideModeOn) => { dispatch({ type: rts.handleWideMode, dispatch, wideModeOn }) },
  }
}

